import { Row, Col } from 'antd';
import {
  InputField,
  SelectField,
  ListOptionsField,
  RadioGroupField,
} from '@/components/Form';
import {
  AGREE_OPTIONS,
  FREQUENCY_OPTIONS,
  MONTHS,
  YEARS,
} from '@/constant/options';
import { currencies } from '@/utils/currenciesUtils';
import { Control } from 'react-hook-form';
import { ALLOWANCES_TYPES_OPTIONS } from '../../constant/optionList';
import { COMMISSION_YEARS } from '../../../Purchase/constant/optionList';
import FormMainLabel from '@/components/Elements/Heading/FormMainLabel';
import { useEffect } from 'react';
interface CoapplicantEmployeeFieldsProps {
  control: Control<any>;
  errors: any;
  watchSalaryCurrency: string | undefined;
  watchAllowanceIncome: boolean | undefined;
  watchCommissionIncome: boolean | undefined;
  watchAnnualCashBonus: boolean | undefined;
  watchStockUnit: boolean | undefined;
  resetField: any;
}

export const CoapplicantEmployeeField: React.FC<
  CoapplicantEmployeeFieldsProps
> = ({
  control,
  errors,
  watchSalaryCurrency,
  watchAllowanceIncome,
  watchCommissionIncome,
  watchAnnualCashBonus,
  watchStockUnit,
  resetField,
}) => {
  useEffect(() => {
    if (watchAllowanceIncome === false) {
      resetField('coapplicantAllowanceIncome');
      resetField('coapplicantAllowanceFrequency');
      resetField('coapplicantTypeOfAllowanceIncome');
    }
  }, [watchAllowanceIncome]);

  useEffect(() => {
    if (watchCommissionIncome === false) {
      resetField('coapplicantCommissionIncome');
      resetField('coapplicantCommissionFrequency');
      resetField('coapplicantCommissionYears');
    }
  }, [watchCommissionIncome]);

  useEffect(() => {
    if (watchAnnualCashBonus === false) {
      resetField('coapplicantThisYearAnnualCashBonus');
      resetField('coapplicantLastYearAnnualCashBonus');
    }
  }, [watchAnnualCashBonus]);

  useEffect(() => {
    if (watchStockUnit === false) {
      resetField('coapplicantThisYearStockOptions');
      resetField('coapplicantLastYearStockOptions');
    }
  }, [watchStockUnit]);

  return (
    <Col xl={24}>
      <Row gutter={[12, 12]}>
        <Col xs={24}>
          <FormMainLabel
            index={4}
            label="When did the coapplicant start their current job?"
          />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            showSearch
            options={MONTHS}
            name="coapplicantJobStartMonth"
            control={control}
            size="large"
            label="Started Month"
            placeholder="Select job start month"
            error={errors?.coapplicantJobStartMonth?.message ?? ''}
          />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            showSearch
            options={YEARS}
            name="coapplicantJobStartYear"
            control={control}
            size="large"
            label="Started Year"
            placeholder="Select job start year"
            error={errors?.coapplicantJobStartYear?.message ?? ''}
          />
        </Col>
        <Col xs={24}>
          <FormMainLabel index={5} label="What's the coapplicant Occupation?" />
        </Col>
        <Col xs={24}>
          <InputField
            label="What's the coapplicant Occupation?"
            name="coapplicantOccupation"
            control={control}
            error={errors?.coapplicantOccupation?.message ?? ''}
            placeholder="Enter your occupation"
            size="large"
          />
        </Col>
        <Col xs={24}>
          <FormMainLabel
            index={6}
            label="What's the coapplicant salary income?"
          />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            showSearch
            options={currencies}
            name="coapplicantSalaryCurrency"
            control={control}
            size="large"
            label="Salary Currency"
            placeholder="Select your salary currency"
            error={errors?.coapplicantSalaryCurrency?.message ?? ''}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Base Salary"
            name="coapplicantBaseSalary"
            control={control}
            error={errors?.coapplicantBaseSalary?.message ?? ''}
            placeholder="Enter coapplicant base salary"
            size="large"
            type="number"
            prefix={watchSalaryCurrency ?? ''}
          />
        </Col>
        <Col xs={24} md={12}>
          <SelectField
            label="Salary Frequency"
            name="coapplicantSalaryFrequency"
            placeholder="Select your salary frequency"
            control={control}
            error={errors?.coapplicantSalaryFrequency?.message ?? ''}
            size="large"
            options={FREQUENCY_OPTIONS}
          />
        </Col>
        <Col xs={24}>
          <FormMainLabel
            index={7}
            label="What's the coapplicant allowance income?"
          />
        </Col>
        <Col xs={24}>
          <RadioGroupField
            size="large"
            name="coapplicantReceiveAllowanceIncome"
            options={AGREE_OPTIONS}
            error={errors?.coapplicantReceiveAllowanceIncome?.message ?? ''}
            control={control}
          />
        </Col>
        {watchAllowanceIncome && (
          <>
            <Col xs={24} md={12}>
              <InputField
                label="Allowance Income"
                name="coapplicantAllowanceIncome"
                control={control}
                placeholder="Enter coapplicant allowance income"
                size="large"
                type="number"
                prefix={watchSalaryCurrency ?? ''}
                error={errors?.coapplicantAllowanceIncome?.message ?? ''}
              />
            </Col>
            <Col xs={24} md={12}>
              <SelectField
                label="Allowance Frequency"
                name="coapplicantAllowanceFrequency"
                placeholder="Select your allowance frequency"
                control={control}
                error={errors?.coapplicantAllowanceFrequency?.message ?? ''}
                size="large"
                options={FREQUENCY_OPTIONS}
              />
            </Col>
            <Col xs={24}>
              <RadioGroupField
                size="large"
                name="coapplicantTypeOfAllowanceIncome"
                options={ALLOWANCES_TYPES_OPTIONS}
                label="Type of allowance?"
                error={errors?.coapplicantTypeOfAllowanceIncome?.message ?? ''}
                control={control}
                multiple={true}
              />
            </Col>
          </>
        )}
        <Col xs={24}>
          <FormMainLabel
            index={8}
            label="What's the coapplicant commission income?"
          />
        </Col>
        <Col xs={24}>
          <RadioGroupField
            size="large"
            name="coapplicantReceiveCommissionIncome"
            options={AGREE_OPTIONS}
            error={errors?.coapplicantReceiveCommissionIncome?.message ?? ''}
            control={control}
          />
        </Col>
        {watchCommissionIncome && (
          <>
            <Col xs={24} md={12}>
              <InputField
                label="What is your commission Income?"
                name="coapplicantCommissionIncome"
                control={control}
                placeholder="Enter coapplicant commission income"
                size="large"
                type="number"
                prefix={watchSalaryCurrency ?? ''}
                error={errors?.coapplicantCommissionIncome?.message ?? ''}
              />
            </Col>
            <Col xs={24} md={12}>
              <SelectField
                label="Commission Frequency"
                placeholder="Select your commission frequency"
                name="coapplicantCommissionFrequency"
                control={control}
                error={errors?.coapplicantCommissionFrequency?.message ?? ''}
                size="large"
                options={FREQUENCY_OPTIONS}
              />
            </Col>
            <Col xs={24}>
              <SelectField
                name="coapplicantCommissionYears"
                options={COMMISSION_YEARS}
                control={control}
                size="large"
                label="How long have you been receiving this commission?"
                placeholder="Select years"
                error={errors?.commissionYears?.message ?? ''}
              />
            </Col>
          </>
        )}
        <Col xs={24}>
          <FormMainLabel
            index={9}
            label="What's the coapplicant annual cash bonus?"
          />
        </Col>
        <Col xs={24}>
          <RadioGroupField
            size="large"
            name="coapplicantReceiveAnnualCashBonus"
            options={AGREE_OPTIONS}
            error={errors?.coapplicantReceiveAnnualCashBonus?.message ?? ''}
            control={control}
          />
        </Col>
        {watchAnnualCashBonus && (
          <>
            <Col xs={24} md={12}>
              <InputField
                label="This Year Cash Bonus"
                name="coapplicantThisYearAnnualCashBonus"
                control={control}
                placeholder="Enter coapplicant this year annual cash bonus"
                size="large"
                type="number"
                prefix={watchSalaryCurrency ?? ''}
                error={
                  errors?.coapplicantThisYearAnnualCashBonus?.message ?? ''
                }
              />
            </Col>
            <Col xs={24} md={12}>
              <InputField
                label="Last Year Cash Bonus"
                name="coapplicantLastYearAnnualCashBonus"
                control={control}
                placeholder="Enter coapplicant last year annual cash bonus"
                size="large"
                type="number"
                prefix={watchSalaryCurrency ?? ''}
                error={
                  errors?.coapplicantLastYearAnnualCashBonus?.message ?? ''
                }
              />
            </Col>
          </>
        )}
        <Col xs={24}>
          <FormMainLabel
            index={10}
            label="Do you receive stock options/restricted stock units?"
          />
        </Col>
        <Col xs={24}>
          <RadioGroupField
            size="large"
            name="coapplicantReceiveStockUnit"
            options={AGREE_OPTIONS}
            error={errors?.coapplicantReceiveStockUnit?.message ?? ''}
            control={control}
          />
        </Col>
        {watchStockUnit && (
          <>
            <Col xs={24} md={12}>
              <InputField
                label="This Year Stock Options"
                name="coapplicantThisYearStockOptions"
                control={control}
                placeholder="Enter coapplicant this year stock options"
                size="large"
                type="number"
                prefix={watchSalaryCurrency ?? ''}
                error={errors?.coapplicantThisYearStockOptions?.message ?? ''}
              />
            </Col>
            <Col xs={24} md={12}>
              <InputField
                label="Last Year Stock Options"
                name="coapplicantLastYearStockOptions"
                control={control}
                placeholder="Enter coapplicant last year stock options"
                size="large"
                type="number"
                prefix={watchSalaryCurrency ?? ''}
                error={errors?.coapplicantLastYearStockOptions?.message ?? ''}
              />
            </Col>
          </>
        )}
      </Row>
    </Col>
  );
};
